export const restrictedData: string[] = ["EM000002"]